module.exports = __webpack_public_path__ + "static/media/aama_ko_maya_heading.0f427075.png";